import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import UnitDetails from './UnitDetails';
import { Paragraph } from 'components/core/Typography/Typography';
import './UnitList.scss';

export function UnitList({
	children,
	className,
	facility,
	phone,
	units,
	unitDetailsComponentProps,
	unitDetailsComponent,
	isVipUnit,
	showIcons,
	searchParams,
	searchType
}) {
	const expectedSizes = [
		{ category: 'small', label: "5' x 5'" },
		{ category: 'medium', label: "5' x 10'" },
		{ category: 'large', label: "10' x 10'" },
	];
	
	// Only show missing unit placeholders for non-vehicle storage
	const shouldShowMissing = units && units.length < 3 && !searchParams?.sqft && searchType !== 'vehicle';
	
	const unitListItems = shouldShowMissing
		? expectedSizes.map(({ category, label }) => {
			const unitForCategory = units?.find((unit) => unit.sizeCategory === category);
			
			if (unitForCategory) {
				// Render actual unit
				const props = {
					...unitDetailsComponentProps(unitForCategory),
					unit: unitForCategory,
					facility,
					showIcon: showIcons,
					phone,
					key: unitForCategory.id,
				};
				return React.createElement(unitDetailsComponent, props);
			} else {
				// Render missing unit placeholder
				return (
					<Paragraph 
						key={`missing-${category}`}
						size="small"
						weight="bold"
						color="gray"
						className="atomic-unit-details-empty unit-list-item"
					>
						No {label} Units Available
					</Paragraph>
				);
			}
		})
		: units?.map((unit) => {
			const props = {
				...unitDetailsComponentProps(unit),
				unit,
				facility,
				showIcon: showIcons,
				phone,
				key: unit.id,
			};
			return React.createElement(unitDetailsComponent, props);
		});

	return (
		<div
			className={classnames(
				className,
				'atomic-unit-list',
				'unit-list',
				{ vip: isVipUnit },
			)}
		>
			{unitListItems}
			{children}
		</div>
	);
}

UnitList.propTypes = {
	/** Immutable list of units */
	units: PropTypes.arrayOf(PropTypes.object),
	facility: PropTypes.object.isRequired,
	/** The component to render the unit with */
	unitDetailsComponent: PropTypes.func,
	unitDetailsComponentProps: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node,
	phone: PropTypes.object,
	isVipUnit: PropTypes.bool,
	showIcons: PropTypes.bool,
	searchParams: PropTypes.object,
	searchType: PropTypes.string,
};

UnitList.defaultProps = {
	units: [],
	unitDetailsComponent: UnitDetails,
	unitDetailsComponentProps: () => {},
};

export default UnitList;

